import type { TournamentFragment } from '~/client/features/Tournaments/graphql/TournamentFragment.generated';
import DefaultLeaderboard from './DefaultLeaderboard';
import TopThree from './TopThree';

type Props = {
  tournament?: TournamentFragment;
};

const topThreeUsers = 3;
const ShortLeaderboard: React.FC<Props> = ({ tournament }) => {
  const { myScore, leaderboard } = tournament || {};
  const showTopThree =
    (leaderboard?.length ?? 0) >= topThreeUsers &&
    (myScore?.position ?? 0) <= topThreeUsers;
  return (
    <div className="relative grid w-[11.25rem] gap-1">
      {showTopThree ? (
        <TopThree leaderboard={leaderboard} />
      ) : (
        <DefaultLeaderboard myScore={myScore} />
      )}
    </div>
  );
};

export default ShortLeaderboard;
